export const AppErrorBoundary = () => {
    return (
        <p>Something went wrong</p>
    )
}
